import './index.styl'

export default {
  name: 'ServerError',
  render(h, context) {
    window.document.title = '502'
    return (
      <div class="server-error-page">
        <img src="https://image.wxopen.shenhudong.com/v4-wechat-fonted/static/icon/server-error.svg" alt="image" />
        <div class="desc">服务器耍脾气，请稍后再试</div>
      </div>
    )
  }
}